import React, { createContext, useEffect, useState } from 'react';
import WeeksSelect from './WeeksSelect';
import BasicForm from './BasicForm';
import MasterForm from './MasterForm';
import useForm from '../../../../shared/hooks/UseForm';
import { fetchWeeks } from '../../../features/reportApi';

export const ReportFormContext = createContext();

const ReportForm = (props) => {
  const [masterAllowed, setMasterAllowed] = useState(false);
  const [weeksChoices, setWeeksChoices] = useState([]);
  const { formData, updateFormData, handleInputChange, handleSelectChange } = useForm({
    id: 0,
    postedVideos: props.postedVideosChoices[0],
    lyricUses: null,
    masterUses: null,
    masterSource: null,
    titles: []
  });

  useEffect(() => {
    fetchWeeks().then(({ options, hasMaster }) => {
      setWeeksChoices(options);
      setMasterAllowed(hasMaster);
    });
  }, []);

  useEffect(() => {
    for (const field in props.dataToFill) {
      updateFormData(field, props.dataToFill[field]);
    }
  }, [props.dataToFill]);

  useEffect(() => {
    if (props.onChange) {
      props.onChange(formData);
    }
  }, [formData]);

  return (
    <ReportFormContext.Provider value={{ formData, handleInputChange, handleSelectChange, updateFormData }}>
      <form name={'reportForm'}>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1'>
            <WeeksSelect weeksChoices={weeksChoices} />
            <BasicForm
              postedVideosChoices={props.postedVideosChoices}
              lyricUsesChoices={props.lyricUsesChoices}
            />
            {/* <MasterForm // SML-127 Temporary hide master recording permissions
              masterUsesChoices={props.masterUsesChoices}
              masterSourceChoices={props.masterSourceChoices}
              showMaster={props.master && masterAllowed}
            /> */}
          </div>
        </div>
      </form>
    </ReportFormContext.Provider>
  );
};

export default ReportForm;
